export default "__VITE_ASSET__LH$HFPDc__"